import { useEffect, useState } from 'react';
import { Message } from '../types';
import ShareButton from '../components/ShareButton';
import MessageBubble from '../components/MessageBubble';
import { generateShareImage, shareBlobOrDownload } from '../utils/shareImage';
import { goHome } from '../routes';

interface SnapshotResponse {
  messages: Message[];
  createdAt?: number;
  error?: string;
}

interface ShareViewProps {
  id: string;
}

export default function ShareView({ id }: ShareViewProps) {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`/api/share/${id}`);
        const data = (await res.json()) as SnapshotResponse;
        if (!res.ok) {
          setError(data.error || 'Линкът е изветрял');
          setLoading(false);
          return;
        }
        setMessages(data.messages || []);
      } catch (err) {
        console.error(err);
        setError('Линкът е изветрял');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const handleShareImage = async () => {
    if (!messages.length) return;
    const blob = await generateShareImage(messages, {
      watermark: 'botkop.pages.dev',
      label: 'Сатира / Пародия',
      botName: 'BOTKOP',
      botAvatar: '/kopeikabot.webp',
    });
    const preferNative = window.innerWidth < 980;
    await shareBlobOrDownload(blob, 'botkop-share.png', preferNative, 'botkop.pages.dev');
  };

  return (
    <div className="share-view">
      <div className="share-view-header">
        <div>
          <p className="pill">Архивиран чат</p>
          <h1>Споделен момент</h1>
          <p className="subtitle">само за четене — няма вход, няма акаунт</p>
        </div>
        <div className="share-view-actions">
          <button className="outline" onClick={goHome}>
            Към бота
          </button>
          <ShareButton label="Шерни снимка" onShare={handleShareImage} />
        </div>
      </div>

      {loading && <div className="share-view-panel">Зареждам линка...</div>}
      {error && !loading && (
        <div className="share-view-panel error">{error}</div>
      )}

      {!loading && !error && (
        <div className="share-view-panel">
          <div className="messages static">
            {messages.map((msg, idx) => (
              <MessageBubble
                key={idx}
                message={msg}
                index={idx}
                showShare={false}
              />
            ))}
          </div>
        </div>
      )}

      <div className="share-view-footer">
        <button className="outline" onClick={handleCopyLink}>
          {copied ? 'Копирано' : 'Копирай линк'}
        </button>
        <button className="primary" onClick={goHome}>
          Към бота
        </button>
      </div>
    </div>
  );
}
